import { render, staticRenderFns } from "./mocktest.vue?vue&type=template&id=2fb4041c&scoped=true&"
import script from "./mocktest.vue?vue&type=script&lang=js&"
export * from "./mocktest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4041c",
  null
  
)

export default component.exports